@let t = text();

<div class="mind-log" data-test-id="mind-log-panel">
  <header class="mind-log__head">
    <span class="mind-log__count" data-test-id="mind-log-count">{{ t.count(entries().length) }}</span>
    @if (preset()) {
      <button type="button" class="mind-log__new" (click)="openNew()" data-test-id="mind-log-new">
        <i class="fas fa-brain" aria-hidden="true"></i>
        {{ t.newNote }}
      </button>
    }
  </header>

  @if (top().length > 0) {
    <!-- De vaakst genoemde conditioneerders: patroonherkenning in één oogopslag. -->
    <div class="mind-log__top" data-test-id="mind-log-top">
      <span class="mind-log__label">{{ t.topConditioners }}</span>
      @for (item of top(); track item.key) {
        <span class="mind-log__chip mind-log__chip--conditioner" [class.mind-log__chip--person]="item.kind === 'person'">
          @if (item.glyph) {
            <span class="mind-log__glyph" [style.color]="item.color" aria-hidden="true">{{ item.glyph }}</span>
          }
          {{ item.label }}
          <span class="mind-log__chip-count">{{ item.count }}</span>
        </span>
      }
    </div>
  }

  @if (entries().length > 0) {
    <div class="mind-log__filters">
      <div class="mind-log__filter-row">
        <span class="mind-log__label">{{ t.filterCenter }}</span>
        <div class="mind-log__chips">
          <button type="button" class="mind-log__chip"
                  [class.mind-log__chip--active]="centerFilter() === undefined"
                  (click)="centerFilter.set(undefined)"
                  data-test-id="mind-log-filter-all">
            {{ t.allCenters }}
          </button>
          @for (chip of centerChips(); track chip.center ?? 'none') {
            <button type="button" class="mind-log__chip"
                    [class.mind-log__chip--active]="centerFilter() === chip.center"
                    (click)="setCenterFilter(chip.center)"
                    [attr.data-test-id]="'mind-log-filter-' + (chip.center ?? 'none')">
              {{ chip.center ? t.centerName(chip.center) : t.noCenter }}
              <span class="mind-log__chip-count">{{ chip.count }}</span>
            </button>
          }
        </div>
      </div>
      <div class="mind-log__filter-row">
        <span class="mind-log__label">{{ t.filterKind }}</span>
        <e-segmented-toggle
          [options]="t.kindOptions"
          [value]="kindFilter()"
          size="xs"
          testId="mind-log-kind"
          (valueChange)="setKindFilter($event)"
        ></e-segmented-toggle>
      </div>
    </div>
  }

  @if (entries().length === 0) {
    <p class="mind-log__empty" data-test-id="mind-log-empty">{{ t.empty }}</p>
  } @else if (filtered().length === 0) {
    <p class="mind-log__empty">{{ t.emptyFiltered }}</p>
  } @else {
    @for (group of groups(); track group.center ?? 'none') {
      <section class="mind-log__group" [attr.data-test-id]="'mind-log-group-' + (group.center ?? 'none')">
        <h5 class="mind-log__group-title">
          <span>{{ group.center ? t.centerName(group.center) : t.noCenter }}</span>
          <span class="mind-log__group-count">{{ group.entries.length }}</span>
        </h5>
        @for (entry of group.entries; track entry.relationId) {
          <button type="button" class="mind-log__row" [title]="t.open" (click)="openEntry(entry)"
                  [attr.data-test-id]="'mind-log-entry-' + entry.relationId">
            <span class="mind-log__when">
              <span class="mind-log__date">{{ entry.dateText }}</span>
              <span class="mind-log__time">{{ entry.timeText }}</span>
            </span>
            <span class="mind-log__excerpt">{{ entry.excerpt || entry.name }}</span>
            <span class="mind-log__badges">
              @if (entry.gate) {
                <span class="mind-log__badge mind-log__badge--gate">{{ t.gate(entry.gate) }}</span>
              }
              @for (badge of conditionerBadges(entry); track $index) {
                <span class="mind-log__badge mind-log__badge--conditioner" [class.mind-log__badge--person]="badge.kind === 'person'">
                  @if (badge.glyph) {
                    <span class="mind-log__glyph" [style.color]="badge.color" aria-hidden="true">{{ badge.glyph }}</span>
                  }
                  {{ badge.label }}
                </span>
              }
            </span>
          </button>
        }
      </section>
    }
  }
</div>

<!-- Nieuwe mind-notitie vanuit het paneel: dezelfde momentdialoog, categorie Mind voorgeselecteerd. -->
<hd-moment-link-dialog
  [(target)]="dialogTarget"
  [sourcePreset]="preset()"
  [defaultCategory]="mindCategory"
  initialMode="thought"
  (changed)="onChanged()"
></hd-moment-link-dialog>
